import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Radio } from '../../../../common/html/radio'
import { CREATE_PROFILE_TYPE } from '../constant'
import {
  changeCreateProfileType,
  selectCreateProfileType,
} from '../store/slice'
import { SelectProfile } from './SelectProfile'

export const CreateType = () => {
  const dispatch = useDispatch()

  const createProfileType = useSelector(selectCreateProfileType)

  const onChange = (value) => {
    dispatch(changeCreateProfileType(value))
  }

  return (
    <div className="mt1">
      <Element className="fw600" style={{ color: '#191D25', marginBottom: 2 }}>
        <Translate value="alertSetting.NEW_ALERT_PROFILE" />
      </Element>
      <Element className="dFlex gap2" style={{ color: '#3A414B' }}>
        <div>
          <Radio
            title="alertSetting.CREATE_A_NEW_ALERT_PROFILE"
            isI18n
            isCheckOnClickText
            activeValue={createProfileType}
            value={CREATE_PROFILE_TYPE.NEW}
            onChange={onChange}
          />
        </div>
        <div>
          <Radio
            title="alertSetting.CREATE_FROM_EXISTING_PROFILE"
            isI18n
            isCheckOnClickText
            activeValue={createProfileType}
            value={CREATE_PROFILE_TYPE.FROM_EXIST}
            onChange={onChange}
          />
          {createProfileType === CREATE_PROFILE_TYPE.FROM_EXIST && (
            <SelectProfile />
          )}
        </div>
      </Element>
    </div>
  )
}
